import React from 'react';
import {t} from '@lingui/core/macro';

import styles from './NoIssuesBlock.module.scss';

const CheckBlock: React.FC = () => (
    <div className={styles.monitorItem}>
        <div className={styles.no_problems}>
            {t`Выполняется проверка`}
        </div>
    </div>
);

export default CheckBlock;